/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { skillsGetShared } from "../funcs/skillsGetShared.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  GetSharedSkillRequest,
  GetSharedSkillResponse,
} from "../models/operations/getsharedskill.js";
import { unwrapAsync } from "../types/fp.js";
export type SharedSkillQueryData = GetSharedSkillResponse;

export function prefetchSharedSkill(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetSharedSkillRequest,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSharedSkillQuery(
      client$,
      request,
      options,
    ),
  });
}

export function buildSharedSkillQuery(
  client$: GramCore,
  request: GetSharedSkillRequest,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<SharedSkillQueryData>;
} {
  return {
    queryKey: queryKeySharedSkill({ token: request.token }),
    queryFn: async function sharedSkillQueryFn(
      ctx,
    ): Promise<SharedSkillQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(skillsGetShared(
        client$,
        request,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySharedSkill(parameters: { token: string }): QueryKey {
  return ["@gram/client", "skills", "getShared", parameters];
}
